import { render, staticRenderFns } from "./CookieComponent.vue?vue&type=template&id=08a8cd92&"
import script from "./CookieComponent.vue?vue&type=script&lang=js&"
export * from "./CookieComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports